/*!

=========================================================
* Paper Kit React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-kit-react

* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// nodejs library that concatenates strings
import classnames from "classnames";
// reactstrap components
import {
  Button,
  Collapse,
  Navbar,
  NavItem,
  Nav,
  Container,
} from "reactstrap";

import { NavLink } from 'react-router-dom';

function IndexNavbar() {
  const [navbarColor, setNavbarColor] = React.useState("navbar-transparent");
  const [navbarCollapse, setNavbarCollapse] = React.useState(false);

  const toggleNavbarCollapse = () => {
    setNavbarCollapse(!navbarCollapse);
    document.documentElement.classList.toggle("nav-open");
  };

  React.useEffect(() => {
    const updateNavbarColor = () => {
      if (
        document.documentElement.scrollTop > 299 ||
        document.body.scrollTop > 299
      ) {
        setNavbarColor("bg-dark");
      } else if (
        document.documentElement.scrollTop < 300 ||
        document.body.scrollTop < 300
      ) {
        setNavbarColor("navbar-transparent");
      }
    };

    window.addEventListener("scroll", updateNavbarColor);

    return function cleanup() {
      window.removeEventListener("scroll", updateNavbarColor);
    };
  });
  return (
    <Navbar className={classnames("fixed-top", navbarColor)} expand="lg">
      <Container>
        <div className="navbar-translate">
          <NavLink to="/" exact className="navbar-brand">
            LUCHOMOTOS
          </NavLink>
          <button aria-expanded={navbarCollapse} className={classnames("navbar-toggler navbar-toggler", { toggled: navbarCollapse, })} onClick={toggleNavbarCollapse}>
            <span className="navbar-toggler-bar bar1" />
            <span className="navbar-toggler-bar bar2" />
            <span className="navbar-toggler-bar bar3" />
          </button>
        </div>
        <Collapse className="justify-content-end" navbar isOpen={navbarCollapse} >
          <Nav navbar>

            <NavItem>
              <a data-placement="bottom" href="https://www.facebook.com/LUCHO-MOTOS-1763794007253610" target="_blank" title="Siguenos en Facebook" className="nav-link" rel="noopener noreferrer">
                <i className="fa fa-facebook-square" />
                <p className="d-lg-none">Facebook</p>
              </a>
            </NavItem>
            <NavItem>
              <a data-placement="bottom" href="https://instagram.com/motoslucho" target="_blank" title="Siguenos en Instagram" className="nav-link" rel="noopener noreferrer">
                <i className="fa fa-instagram" />
                <p className="d-lg-none">Instagram</p>
              </a>
            </NavItem>
            <NavItem>
              <a data-placement="bottom" href="https://pipe-code.github.io" target="_blank" title="PIPE:CODE GitHub" className="nav-link" rel="noopener noreferrer">
                <i className="fa fa-github" />
                <p className="d-lg-none">DEVELOPER</p>
              </a>
            </NavItem>
            <NavItem>
              <NavLink to="/contacto" exact>
                <Button className="btn-round" color="danger">
                  CONTACTANOS
                </Button>
              </NavLink>
            </NavItem>

          </Nav>
        </Collapse>
      </Container>
    </Navbar>
  );
}

export default IndexNavbar;
